<div [style.display]="inline ? 'none' : 'block'" #colorDisplay class="color-display" (click)="togglePopover()"></div>
<div #pickerBox class="picker-box" [style.display]="inline || popoverVisible ? 'block' : 'none'" [style.position]="inline ? 'static' : 'absolute'">
    <div class="picker-content">
        <div class="circle-wrapper">
            <canvas #colorWheel class="colorWheel" width="200" height="200"></canvas>
        </div>
        <svg #wheelSelector class="wheel-selector" width="16" height="16" style="position:absolute; pointer-events:none; overflow: visible;">
            <circle cx="8" cy="8" r="8" stroke="black" stroke-width="2" fill="none" />
            <circle cx="8" cy="8" r="6" stroke="white" stroke-width="2" fill="none" />
        </svg>
        <div #valueSlider class="slider">
            <svg #valueSliderHandle class="slider-handle" width="16" height="16" style="position:absolute; pointer-events:none; overflow: visible;">
                <circle cx="8" cy="8" r="8" stroke="black" stroke-width="2" fill="none" />
                <circle cx="8" cy="8" r="6" stroke="white" stroke-width="2" fill="none" />
            </svg>
        </div>
        <div #alphaSlider [style.display]="alpha != null ? 'block' : 'none'" class="slider">
            <svg #alphaSliderHandle class="slider-handle" width="16" height="16" style="position:absolute; pointer-events:none; overflow: visible;">
                <circle cx="8" cy="8" r="8" stroke="black" stroke-width="2" fill="none" />
                <circle cx="8" cy="8" r="6" stroke="white" stroke-width="2" fill="none" />
            </svg>
        </div>
    </div>
    <div class="rgb-fields">
        <input #hexField class="hexField">
        <input #rField class="rField" type="number" min="0" max="255">
        <input #gField class="gField" type="number" min="0" max="255">
        <input #bField class="bField" type="number" min="0" max="255">
    </div>

    <div class="rgb-labels">
        <span>Hex</span>
        <span>R</span>
        <span>G</span>
        <span>B</span>
    </div>
</div>
